export default "__VITE_ASSET__CHVqjnrE__"